import { component } from 'picoapp';
import { register } from 'swiper/swiper-element-bundle';

class Slider {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init(el);
  }

  init(el) {

    this.slider = el.querySelector('swiper-container');

    this.customSettings = el.querySelector('[data-type="slider-settings"]') ? JSON.parse(el.querySelector('[data-type="slider-settings"]').text) : {}

    const swiperParams = {
      spaceBetween: 16,
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(this.slider, { ...swiperParams, ...this.customSettings });
    register();
    this.slider.initialize();

    this.customButtons = el.querySelectorAll('.swiper-button')
    this.customButtons.forEach(btn => {
      btn.addEventListener('click', e => e.stopPropagation())
    });
    if (!!this.el.querySelector('swiper-slide video')) {
      this.bindVideoEvents()
    }
  }

  bindVideoEvents() {
    this.slider.swiper.on('slideChangeTransitionEnd', swiper => {
      const slides = [...swiper.slides]
      slides.forEach(slide => {
        const video = slide.querySelector("video")
        if (!!video) {
          video.pause();
          video.currentTime = 0;
        }
      })
      const activeSlideEl = swiper.slides[swiper.activeIndex]
      activeSlideEl.querySelector('video')?.play()
    })

    /* function handleVideoIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Item has crossed our observation
          entry.target.play()
          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }
    const videos = document.querySelectorAll('video')

    const IOOptions = {
      root: null, threshold: 1.0
    }

    const observer = new IntersectionObserver(handleVideoIntersection, IOOptions);
    if (videos) {
      videos.forEach(video => observer.observe(video));
    } */
  }
}

// module.exports = Slider;
export default component((node, ctx) => {
  new Slider(node, ctx);
});
